import { useCustomStyleHook_unstable } from '@fluentui/react-shared-contexts';
import { forwardRef } from 'react';
import {
    renderTagPickerInput_unstable,
    useTagPickerContext_unstable,
    useTagPickerInput_unstable,
    useTagPickerInputStyles_unstable,
} from '@fluentui/react-components';

export const CustomTagPickerInput = forwardRef((props, ref) => {
    const state = useTagPickerInput_unstable(props, ref as any);
    const open = useTagPickerContext_unstable((ctx) => ctx.open);
    const setOpen = useTagPickerContext_unstable((ctx) => ctx.setOpen);
    const onKeyDown = state.root.onKeyDown!;
    state.root.onKeyDown = (event) => {
        if (open) {
            onKeyDown(event);
        } else {
            event.ctrlKey && setOpen(event, true);
        }
    };
    useTagPickerInputStyles_unstable(state);
    useCustomStyleHook_unstable('useTagPickerInputStyles_unstable')(state);
    return renderTagPickerInput_unstable(state);
});
CustomTagPickerInput.displayName = 'CustomTagPickerInput';
